// 261005 E5 vòng 4 — màu tên nhân vật trong kịch bản: ~8 màu dịu, ỔN ĐỊNH theo khoá (characterId hoặc tên). Hàm thuần (jest).
export const CHARACTER_COLOR_COUNT = 8;

/** Chỉ số màu 0..7 theo khoá; cùng khoá ⇒ luôn cùng chỉ số. Khoá rỗng ⇒ 0. */
export const characterColorIndex = (key: string | null | undefined): number => {
  const s = String(key ?? '').trim().toLowerCase();
  if (!s) return 0;
  let h = 5381;
  for (let i = 0; i < s.length; i += 1) h = ((h * 33) ^ s.charCodeAt(i)) >>> 0;
  return h % CHARACTER_COLOR_COUNT;
};

/** Style gắn lên khối thoại: `--ch-fg` (tên) và `--ch-ln` (vạch trái) trỏ tới token `--wb-chN-*` (tự đổi sáng/tối). */
export const characterColorStyle = (key: string | null | undefined): Record<string, string> => {
  const i = characterColorIndex(key);
  return { '--ch-fg': `var(--wb-ch${i}-fg)`, '--ch-ln': `var(--wb-ch${i}-ln)` };
};
